@if (
  {
    row: columnData | async,
  };
  as $
) {
  @if ($.row && ($.row.subfreeze_type || $.row.freeze_type || $.row.type)) {
    <span
      >{{
        getFreezeType($.row.subfreeze_type || $.row.freeze_type || $.row.type)
      }}
    </span>
  }
}
